<!-- Trigger (avatar) button lives in the app toolbar; this component renders only
the popover (outside the backdrop-filtered header so position:fixed works). -->
@if (isOpen$ | async) {
  <div class="profile-overlay" (click)="close()"></div>
  <div class="profile-popover">
    @if (user$() | async; as u) {
      <div class="profile-popover-header">
        <div class="profile-popover-avatar">
          @if (u.avatarId) {
            <img [src]="avatarUrl(u.avatarId)" alt="" />
          } @else {
            {{ u.firstName?.charAt(0) }}{{ u.lastName?.charAt(0) }}
          }
        </div>
        <div class="profile-popover-info">
          <span class="profile-popover-name">{{ u.firstName }} {{ u.lastName }}</span>
          <span class="profile-popover-email">{{ u.email }}</span>
        </div>
      </div>
    }
    <div class="profile-popover-divider"></div>
    <!-- Admin: act-as-tenant switcher (platform admins only) -->
    @if (isPlatformAdmin$ | async) {
      <div class="profile-popover-section">
        <span class="profile-popover-section-label">{{ 'profileMenu.adminTenantContext' | translate }}</span>
        <button class="profile-popover-action" (click)="openTenantSwitcher()">
          <ion-icon name="swap-horizontal-outline"></ion-icon>
          {{ 'profileMenu.switchTenant' | translate }}
        </button>
        <div class="profile-popover-divider"></div>
      </div>
    }
    @if (organizations.length > 1 || orgsError) {
      <div class="profile-popover-section">
        <span class="profile-popover-section-label">{{ 'profileMenu.switchTenant' | translate }}</span>
        @if (orgsError) {
          <p class="profile-popover-error">{{ 'profileMenu.orgsLoadError' | translate }}</p>
        }
        @for (org of organizations; track org) {
          <div class="profile-popover-tenant-row">
            <button class="profile-popover-tenant" [class.profile-popover-tenant--active]="org.isActive"
              (click)="!org.isActive && switchTenant(org.orgId)">
              <ion-icon [name]="org.isActive ? 'checkmark-circle' : 'ellipse-outline'"></ion-icon>
              {{ org.displayName }}
            </button>
            <button class="profile-popover-star" (click)="setDefault(org.orgId, $event)"
              [class.profile-popover-star--active]="org.orgId === defaultOrgId"
              [attr.aria-label]="'profileMenu.setDefault' | translate"
              [appTooltip]="(org.orgId === defaultOrgId ? 'profileMenu.default' : 'profileMenu.setDefault') | translate"
              tooltipPosition="left">
              <ion-icon [name]="org.orgId === defaultOrgId ? 'star' : 'star-outline'"></ion-icon>
            </button>
          </div>
        }
        <div class="profile-popover-divider"></div>
      </div>
    }
    <a class="profile-popover-action" [href]="myProfileUrl" target="_blank" rel="noopener" (click)="close()">
      <ion-icon name="person-outline"></ion-icon>
      {{ 'profileMenu.editProfile' | translate }}
      <ion-icon name="open-outline" class="profile-popover-external" aria-hidden="true"></ion-icon>
    </a>
    <button class="profile-popover-action" (click)="navigateToSettings()">
      <ion-icon name="settings-outline"></ion-icon>
      {{ 'profileMenu.settings' | translate }}
    </button>
    <button class="profile-popover-action" [routerLink]="(supportRoute$ | async) ?? '/contact'" (click)="close()">
      <ion-icon name="help-circle-outline"></ion-icon>
      {{ 'profileMenu.support' | translate }}
    </button>
    <button class="profile-popover-action profile-popover-action--danger" (click)="logout()">
      <ion-icon name="log-out-outline"></ion-icon>
      {{ 'profileMenu.logout' | translate }}
    </button>
    <p class="profile-popover-version">
      <span>v{{ spaVersion }}</span>
      @if (apiVersion$ | async; as apiVersion) {
        <span>API v{{ apiVersion }}</span>
      }
    </p>
  </div>
}
